// src/components/ResetPassword.jsx

import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './LoginScreen.css'; // ✅ reuse shared styles

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);

    const uid = searchParams.get('uid');
    const token = searchParams.get('token');

    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState(null); // optional error message

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); 

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match");
            setLoading(false);
            return;
        }

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/password-reset/confirm`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                uid,
                token,
                new_password: newPassword,
            }),
            });

            if (!res.ok) throw new Error("Reset failed");

            setStatus('success');
            setTimeout(() => navigate('/'), 2000);
        } catch (err) {
            setStatus('error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-wrapper">
            <div className="login-screen">
                <h2>Reset Your Password</h2>

                <form onSubmit={handleSubmit}>
                    <div className="input-with-icon">
                        <input
                        type={showPassword ? 'text' : 'password'}
                        placeholder="New password"
                        value={newPassword}
                        onChange={(e) => {
                            setNewPassword(e.target.value);
                            setError(null);
                        }}
                        required
                        className="input-field"
                        />
                        <i
                        className={`fa-regular ${showPassword ? 'fa-eye' : 'fa-eye-slash'} toggle-icon`}
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label="Toggle password visibility"
                        />
                    </div>

                    <div className="input-with-icon">
                        <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        placeholder="Confirm password"
                        value={confirmPassword}
                        onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            setError(null);
                        }}
                        required
                        className="input-field"
                        />
                        <i
                        className={`fa-regular ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'} toggle-icon`}
                        onClick={() => setShowConfirmPassword((prev) => !prev)}
                        aria-label="Toggle confirm password visibility"
                        />
                    </div>

                    <button type="submit" disabled={loading}>
                        {loading ? 'Resetting…' : 'Reset Password'}
                    </button>
                </form>

                <p className="register-link">
                    {status === 'success' && <span className="success-message">Password reset successful. Redirecting…</span>}
                    {status === 'error' && <span style={{ color: 'red' }}>Invalid or expired token.</span>}
                    {error && <span style={{ color: 'red' }}>{error}</span>}
                </p>
            </div>
            
            {loading && <div className="spinner">Loading…</div>}
        </div>
    );
}
